// ProjectUnit.js

import React, { useState } from 'react';
import classes from './ProjectUnit.module.css';
import { ExternalLink, Link } from 'lucide-react';

const ProjectUnit = (props) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <img src={props.item.image} className={classes['card-img']} alt='' />
        <div
          className={classes.projectUnit}
          onMouseEnter={handleHover}
          onMouseLeave={handleHover}
        >
          <div className={classes.unitName}>{props.item.name}</div>

          <div
            className={`${classes.unitDescription} ${
              isHovered ? classes.show : ''
            }`}
          >
            {props.item.description}
          </div>
          <br />
          <div className={classes.techUsed}>Tech Used: {props.item.tech}</div>
          {/* <br /> */}
          <div className={classes.linkTowebsite}>
            {props.item.liveLink ? (
              <a
                href={props.item.liveLink}
                className={classes['margin-right']}
                target='_blank'
                rel='noreferrer'
              >
                <Link size={30} />
              </a>
            ) : null}
            <a href={props.item.link} target='_blank' rel='noreferrer'>
              <ExternalLink size={35} />
            </a>
          </div>

          <br />
        </div>
      </div>
    </div>
  );
};

export default ProjectUnit;
